import { Link } from "react-router-dom";
import { ArrowRight, Truck, ShieldCheck, ShoppingCart } from "lucide-react";

export const SupplyBanner = () => {
  return (
    <section data-testid="supply-banner" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 sm:py-20">
        <div className="relative overflow-hidden rounded-sm bg-[#1c4f9c]">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://images.pexels.com/photos/34516664/pexels-photo-34516664.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative grid lg:grid-cols-2 gap-8 items-center p-8 sm:p-12 lg:p-14">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-white/80">Elite Supply Co.</p>
              <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-white leading-[1.1]">
                Need cleaning supplies? Shop our online store.
              </h2>
              <p className="mt-4 text-white/80 text-base max-w-lg">
                Auto scrubbers, paper products, chemicals, dispensers and everyday household
                essentials — from reliable suppliers with fast shipping across Florida.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link
                  to="/supply"
                  data-testid="banner-shop-btn"
                  className="inline-flex items-center gap-2 bg-[#e02329] text-white font-bold py-3.5 px-7 rounded-sm hover:bg-[#c81e24] transition-colors"
                >
                  <ShoppingCart size={18} /> Shop Supplies <ArrowRight size={18} />
                </Link>
                <Link
                  to="/supply"
                  data-testid="banner-quote-btn"
                  className="inline-flex items-center gap-2 border-2 border-white text-white font-bold py-3.5 px-7 rounded-sm hover:bg-white hover:text-[#1c4f9c] transition-colors"
                >
                  Request a Bulk Quote
                </Link>
              </div>
            </div>
            <div className="flex flex-col gap-4 lg:pl-8">
              <div className="flex items-start gap-3 bg-white/10 backdrop-blur-sm rounded-sm p-4">
                <Truck className="text-white shrink-0" size={22} />
                <div>
                  <p className="font-bold text-white">Fast shipping to Florida</p>
                  <p className="text-sm text-white/70">Sourced from trusted suppliers and shipped quickly across the state.</p>
                </div>
              </div>
              <div className="flex items-start gap-3 bg-white/10 backdrop-blur-sm rounded-sm p-4">
                <ShieldCheck className="text-white shrink-0" size={22} />
                <div>
                  <p className="font-bold text-white">Commercial &amp; household</p>
                  <p className="text-sm text-white/70">Everything from ride-on scrubbers to affordable everyday essentials.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
